import { KycRedirect } from './kyc-redirect.js';
import { StaffRedirect } from './staff-redirect.js';
import { jsx } from 'react/jsx-runtime';

const RedirectsHandler = _ref => {
  let {
    allowStaff,
    children,
    disableKycRedirect
  } = _ref;
  return /*#__PURE__*/jsx(KycRedirect, {
    disableKycRedirect: disableKycRedirect,
    children: /*#__PURE__*/jsx(StaffRedirect, {
      allowStaff: allowStaff,
      children: children
    })
  });
};

export { RedirectsHandler };
//# sourceMappingURL=handler.js.map
